import { withAuth } from '@/components/layout'
import { TopPage } from '@/components/pages/Top'

export default withAuth(TopPage)
